class LmPdfFooterCtrl {
  constructor(currentUserService) {
    'ngInject';

    this.currentUserService = currentUserService;
  }
}

export default LmPdfFooterCtrl;
